import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    fullWidth: { width: "100% !important", maxWidth: "100% !important" },
    centerElement: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
    },
    descriptionNote: {
      fontWeight: 400,
      color: theme.gray500,
      fontSize: 12,
      margin: theme.spacing(1, 0, 8),
    },
    editAchievementModalInfo: {
      fontSize: 14,
      color: theme.gray500,
    },
    checkboxLabel: {
      color: theme.gray800,
      fontSize: 14,
    },
    link: {
      fontSize: "14px",
      textDecoration: "underline",
    },
    bolded: {
      fontWeight: "bold",
    },
    stepperBox: {
      marginBottom: theme.spacing(12),
    },
    activeToggle: { color: theme.gray800 },
    editIcon: {
      cursor: "pointer",
    },
    summaryBox: {
      padding: theme.spacing(12),
      backgroundColor: theme.gray50,
      borderRadius: "8px",
      "& div": {
        fontSize: 16,
      },
    },
    summaryKey: {
      fontWeight: 500,
      maxWidth: "170px",
    },
    statusValue: {
      "& > div": {
        fontSize: 12,
        display: "inline",
      },
    },
    rulesTabs: {
      marginBottom: theme.spacing(12),
    },
    wrapText: {
      overflowWrap: "break-word",
    },
    vectorMargin: {
      margin: theme.spacing(-7, 0, 0, 0),
    },
    goalAdvancedSettings: {
      backgroundColor: `${theme.white00} !important`,
    },
    goalDescription: {
      "& #boxElement": {
        backgroundColor: theme.white00,
        fontSize: 14,
        minHeight: "24px",
        margin: theme.spacing(2, 2, 2, 0),
        "& > div > div": {
          fontSize: 14,
        },
      },
    },
    error: {
      color: theme.red500,
    },
    userGuide: {
      color: theme.primary500,
      fontSize: 12,
      fontWeight: 600,
      display: "inline-flex",
      alignItems: "start",
      textDecoration: "none",

      "& svg": {
        margin: theme.spacing(1, 0, 0, 1),
        width: 14,
        height: 14,
      },
    },
    separator: {
      borderBottom: `1px solid ${theme.gray100}`,
      position: "relative",
      left: "-20px",
      width: "calc(100% + 40px)",
    },
    content: {
      position: "relative",
      height: `calc(100vh - 63px)`,
    },
    stepsWrapper: {
      margin: "0 auto",
      padding: theme.spacing(0, 2),
      maxWidth: "1198px",
    },
    form: {
      maxWidth: "1198px",
      margin: "0 auto",
      height: "calc(100% - 200px)",
      overflow: "auto",
    },
  }),
);
